import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import {
  ShoppingProducts,
  ShoppingProductsParameters,
  TableTitles,
} from '../../interfaces/ShoppingProductsItem';
import * as g from '../../../../globals';
import { NzMessageService } from 'ng-zorro-antd/message';
import { LayoutService } from '@app/layout/layout.service';
import { switchMap, tap } from 'rxjs/operators';
import { Observable, Subscription, of } from 'rxjs';
import {
  RecordCategory,
  RecordModel,
  RecordProperties,
} from '@app/layout/record-model';
import { Field, ModuleStructure, Section } from '@app/models/module-structure';
import { ShoppingCartService } from '../../shoppingCart.service';
import { ActivatedRoute } from '@angular/router';
import { CartObject } from '../../interfaces/cartObject';
@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.less'],
})
export class ProductDetailsComponent implements OnInit, OnDestroy {
  shoppingCartId: any;
  products: any[] = [];
  recordModel: RecordModel;
  @Input() set product(product: ShoppingProducts) {
    this.getProductDetails(product.ItemCode);
    this.itemCode = product.ItemCode;
  }
  @Input() isTokenized: boolean = true;
  @Input() footerAtTop: boolean = true;
  @Input() inDrawer: boolean = false;
  @Input() CardCode?: string;
  @Input() dbShoppingCart = '1';
  @Input() cart: CartObject;
  @Input() customer?: any;
  @Input() TableColumns: TableTitles[];
  itemCode: string = '';
  structure: ModuleStructure;
  itemsSections: Section;
  picture: {
    field: Field;
    property?: RecordProperties;
  };
  category: RecordCategory;
  values: Map<string, string> = new Map<string, string>();
  subscriptions: Subscription[] = [];
  relationsSection: Section;
  relationPanels: Map<string, any[]> = new Map<string, any[]>();
  items: Map<string, string> = new Map<string, string>();
  isTable: boolean = false;
  additionalSectionVisible = false;
  constructor(
    private layoutService: LayoutService,
    private shoppingCartService: ShoppingCartService,
    private route: ActivatedRoute
  ) {}
  ngOnDestroy(): void {
    this.subscriptions.forEach((x) => x.unsubscribe());
  }
  ngOnInit() {
    this.shoppingCartId = this.route.snapshot.queryParams['ShoppingCartId'];
  }

  getProductDetails(itemCode: string) {
    this.subscriptions.push(
      this.layoutService
        .getModuleStructure(4)
        .pipe(
          switchMap((structure) => {
            this.structure = structure;
            this.itemsSections = this.structure.module.Sections.find(
              (x) => x.XmlTagName === 'Items'
            );
            return this.layoutService.getValuesOnEdit(
              null,
              4,
              encodeURIComponent(itemCode).replace('+', '%2B'),
              false
            ) as Observable<any>;
          }),
          tap((response: { Values: string }) => {
            this.recordModel = JSON.parse(response.Values) as RecordModel;
            this.category = this.recordModel.Categories.find(
              (x) => x.Id === 'Items'
            );
            this.itemsSections.Fields.forEach((field) => {
              const prop = this.category.Lines[0].Properties.find(
                (x) => x.Name === field.PropertyName
              );
              if (field.PropertyName === 'PicturName') {
                this.picture = { field: field, property: prop };
              } else if (prop != null) {
                this.values.set(field.Label, prop?.Value);
              }
            });
            const relationCategory = this.recordModel.Categories.find(
              (x) => x.Id === 'BWEB_ITEM_RELATIONS'
            );
            if (relationCategory != null && relationCategory.Lines.length > 0) {
              relationCategory.Lines.forEach((line) => {
                const rleationName = line.Properties.find(
                  (x) => x.Name === 'U_RELATION_CODE'
                );
                if (rleationName != null) {
                  this.relationPanels.set(rleationName.Value, []);
                  const childItemCodeProp = line.Properties.find(
                    (x) => x.Name === 'U_ITEM_CODE'
                  );
                  if (childItemCodeProp != null) {
                    this.items.set(childItemCodeProp.Value, rleationName.Value);
                  }
                }
              });
            }
          }),
          switchMap(() => {
            if (this.items.size > 0) {
              let filterText = '{"Array.OITM.ItemCode":"[';
              Array.from(this.items.keys()).forEach((item) => {
                filterText += `'${item}',`;
              });
              filterText = filterText.slice(0, -1);
              filterText += ']"}';
              const params: ShoppingProductsParameters = {
                CardCode: this.CardCode,
                CurrentNav: [],
                CurrentPage: 1,
                DbShoppingCartId: this.dbShoppingCart,
                PageCount: '100000',
                Properties: [],
                searchValue: '',
                ShoppingCartId: this.shoppingCartId,
                TableFilter: filterText,
              };
              return this.shoppingCartService.getShoppingItems(params);
            } else {
              return of(null);
            }
          }),
          tap((response) => {
            if (response == null) {
              return;
            }
            this.additionalSectionVisible = true;
            const items = JSON.parse(response) as ShoppingProducts[];
            // this.Items = JSON.parse(data);
            if (
              this.products.length > 0 &&
              this.products.some((x) => x.SelectedQuantity != null)
            ) {
              items.map((item) => {
                const existItem = this.products.find(
                  (x) => x.ItemCode === item.ItemCode
                );
                if (
                  item.SelectedQuantity == null &&
                  item.SelectedQuantity !== 0 &&
                  existItem != null
                ) {
                  Object.keys(existItem).forEach((key) => {
                    item[key] = this.products.find(
                      (x) => x.ItemCode === item.ItemCode
                    )[key];
                  });
                }
              });
            }
            this.products = items;

            const uniqueRelations = new Set(this.items.values());

            Array.from(uniqueRelations).forEach((rel) => {
              const relatedItems = Array.from(this.items.entries())
                .filter(([key, val]) => val === rel)
                .map(([key]) => key);
              const prods = this.products.filter((x) =>
                relatedItems.includes(x.ItemCode)
              );
              this.relationPanels.get(rel).push(...prods);
            });
          })
        )
        .subscribe()
    );
  }

  linkedObjectSubmitted(event) {
    this.layoutService.closeDrawer.emit();
  }
  backButtonClicked() {
    this.layoutService.closeDrawer.emit();
  }
}
